module.exports = __webpack_public_path__ + "static/media/Burger_Builder2.1867ea3d.png";